export const projectValidationSagaActionTypes = {
  // Categories
  callGetCategoriesSaga: "callGetCategoriesSaga",
  callGetCategorySaga: "callGetCategorySaga",
  callCreateCategorySaga: "callCreateCategorySaga",
  callUpdateCategorySaga: "callUpdateCategorySaga",
  callDeleteCategorySaga: "callDeleteCategorySaga",
  // Requirements
  callGetRequirementsSaga: "callGetRequirementsSaga",
  callGetRequirementSaga: "callGetRequirementSaga",
  callCreateRequirementSaga: "callCreateRequirementSaga",
  callUpdateRequirementSaga: "callUpdateRequirementSaga",
  callDeleteRequirementSaga: "callDeleteRequirementSaga",
  // Test Cases
  callGetTestCasesSaga: "callGetTestCasesSaga",
  callGetTestCaseSaga: "callGetTestCaseSaga",
  callCreateTestCaseSaga: "callCreateTestCaseSaga",
  callUpdateTestCaseSaga: "callUpdateTestCaseSaga",
  callDeleteTestCaseSaga: "callDeleteTestCaseSaga",
  // Media Files
  callGetMediaFilesSaga: "callGetMediaFilesSaga",
  callUploadMediaFilesSaga: "callUploadMediaFilesSaga",
  callDeleteMediaFileSaga: "callDeleteMediaFileSaga",
  // Environment details
  callGetEnvironmentDetailsSaga: "callGetEnvironmentDetailsSaga",
  callGetHistoryEnvironmentDetailsSaga: "callGetHistoryEnvironmentDetailsSaga",
};

// Helper function to extract numeric ID from formatted string
export const extractNumericId = (formattedId: string | number): string => {
  if (typeof formattedId === "number") {
    return String(formattedId);
  }
  const parts = formattedId.split("-");
  return parts.length > 1 ? parts[1] : formattedId;
};

// Categories
export const getCategoriesSagaAction: () => {
  type: string;
} = () => {
  return {
    type: projectValidationSagaActionTypes.callGetCategoriesSaga,
  };
};

export const getCategorySagaAction: (id: string | number) => {
  type: string;
  payload: { id: string | number };
} = (id: string | number) => {
  return {
    type: projectValidationSagaActionTypes.callGetCategorySaga,
    payload: { id },
  };
};

export type createCategoryPayloadType = {
  category_name: string;
  description?: string | null;
};

export const createCategorySagaAction: (data: createCategoryPayloadType) => {
  type: string;
  payload: createCategoryPayloadType;
} = (data: createCategoryPayloadType) => {
  return {
    type: projectValidationSagaActionTypes.callCreateCategorySaga,
    payload: data,
  };
};

export type updateCategoryPayloadType = {
  id: string | number;
  category_name: string;
  description?: string | null;
};

export const updateCategorySagaAction: (data: updateCategoryPayloadType) => {
  type: string;
  payload: updateCategoryPayloadType;
} = (data: updateCategoryPayloadType) => {
  return {
    type: projectValidationSagaActionTypes.callUpdateCategorySaga,
    payload: data,
  };
};

export const deleteCategorySagaAction: (id: string | number) => {
  type: string;
  payload: { id: string | number };
} = (id: string | number) => {
  return {
    type: projectValidationSagaActionTypes.callDeleteCategorySaga,
    payload: { id },
  };
};

// Requirements
export const getRequirementsSagaAction: () => {
  type: string;
} = () => {
  return {
    type: projectValidationSagaActionTypes.callGetRequirementsSaga,
  };
};

export const getRequirementSagaAction: (id: string | number) => {
  type: string;
  payload: { id: string | number };
} = (id: string | number) => {
  return {
    type: projectValidationSagaActionTypes.callGetRequirementSaga,
    payload: { id },
  };
};

export type createRequirementPayloadType = {
  category_id: number;
  requirement_type: string;
  technology: number[];
  integration_type: number[];
  test_cases: string[];
  validation_score: string;
  requirement_status: string;
  high_level_scenario?: string | null;
  requirement_description?: string | null;
};

export const createRequirementSagaAction: (
  data: createRequirementPayloadType
) => {
  type: string;
  payload: createRequirementPayloadType;
} = (data: createRequirementPayloadType) => {
  return {
    type: projectValidationSagaActionTypes.callCreateRequirementSaga,
    payload: data,
  };
};

export type updateRequirementPayloadType = {
  id: string | number;
  category_id: number;
  requirement_type: string;
  technology: number[];
  integration_type: number[];
  test_cases: string[];
  validation_score: string;
  requirement_status: string;
  high_level_scenario?: string | null;
  requirement_description?: string | null;
};

export const updateRequirementSagaAction: (
  data: updateRequirementPayloadType
) => {
  type: string;
  payload: updateRequirementPayloadType;
} = (data: updateRequirementPayloadType) => {
  return {
    type: projectValidationSagaActionTypes.callUpdateRequirementSaga,
    payload: data,
  };
};

export const deleteRequirementSagaAction: (id: string | number) => {
  type: string;
  payload: { id: string | number };
} = (id: string | number) => {
  return {
    type: projectValidationSagaActionTypes.callDeleteRequirementSaga,
    payload: { id },
  };
};

// Test Cases
export const getTestCasesSagaAction: () => {
  type: string;
} = () => {
  return {
    type: projectValidationSagaActionTypes.callGetTestCasesSaga,
  };
};

export const getTestCaseSagaAction: (id: string | number) => {
  type: string;
  payload: { id: string | number };
} = (id: string | number) => {
  return {
    type: projectValidationSagaActionTypes.callGetTestCaseSaga,
    payload: { id },
  };
};

export type createTestCasePayloadType = {
  category_id: number;
  high_level_scenario?: string | null;
  pre_conditions?: string | null;
  description?: string | null;
  expected_result?: string | null;
  test_case_status: string;
};

export const createTestCaseSagaAction: (data: createTestCasePayloadType) => {
  type: string;
  payload: createTestCasePayloadType;
} = (data: createTestCasePayloadType) => {
  return {
    type: projectValidationSagaActionTypes.callCreateTestCaseSaga,
    payload: data,
  };
};

export type updateTestCasePayloadType = {
  id: string | number;
  category_id: number;
  high_level_scenario?: string | null;
  pre_conditions?: string | null;
  description?: string | null;
  expected_result?: string | null;
  test_case_status: string;
};

export const updateTestCaseSagaAction: (data: updateTestCasePayloadType) => {
  type: string;
  payload: updateTestCasePayloadType;
} = (data: updateTestCasePayloadType) => {
  return {
    type: projectValidationSagaActionTypes.callUpdateTestCaseSaga,
    payload: data,
  };
};

export const deleteTestCaseSagaAction: (id: string | number) => {
  type: string;
  payload: { id: string | number };
} = (id: string | number) => {
  return {
    type: projectValidationSagaActionTypes.callDeleteTestCaseSaga,
    payload: { id },
  };
};

// Media Files
export const getMediaFilesSagaAction: (integrationId: string) => {
  type: string;
  integrationId: string;
} = (integrationId) => {
  return {
    type: projectValidationSagaActionTypes.callGetMediaFilesSaga,
    integrationId: integrationId,
  };
};

export const uploadMediaFilesSagaAction: (
  integrationId: string,
  files: File[],
  uploadedBy: number,
  createdAt?: string // TEMPORARY: created_at from validation \"Submitted on\" datepicker. Remove with TEMPORARY block.
) => {
  type: string;
  integrationId: string;
  files: File[];
  uploadedBy: number;
  createdAt?: string;
} = (integrationId, files, uploadedBy, createdAt) => {
  return {
    type: projectValidationSagaActionTypes.callUploadMediaFilesSaga,
    integrationId: integrationId,
    files: files,
    uploadedBy: uploadedBy,
    createdAt,
  };
};

export type deleteMediaFilePayloadType = {
  mediaId: number;
  setDeleteModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setFileToDelete: React.Dispatch<
    React.SetStateAction<{ id: number; name: string } | null>
  >;
};

export const deleteMediaFileSagaAction: (data: deleteMediaFilePayloadType) => {
  type: string;
  payload: deleteMediaFilePayloadType;
} = (data: deleteMediaFilePayloadType) => {
  return {
    type: projectValidationSagaActionTypes.callDeleteMediaFileSaga,
    payload: data,
  };
};

// Environment Details
export type getEnvironmentDetailsPayloadType = {
  integration_id: number;
  documentation_id?: number;
};

export const getEnvironmentDetailsSagaAction: (
  data: getEnvironmentDetailsPayloadType
) => {
  type: string;
  payload: getEnvironmentDetailsPayloadType;
} = (data: getEnvironmentDetailsPayloadType) => {
  return {
    type: projectValidationSagaActionTypes.callGetEnvironmentDetailsSaga,
    payload: data,
  };
};

export type getHistoryEnvironmentDetailsPayloadType = {
  integration_id: number;
  documentation_id: number;
};

export const getHistoryEnvironmentDetailsSagaAction: (
  data: getHistoryEnvironmentDetailsPayloadType
) => {
  type: string;
  payload: getHistoryEnvironmentDetailsPayloadType;
} = (data: getHistoryEnvironmentDetailsPayloadType) => {
  return {
    type: projectValidationSagaActionTypes.callGetHistoryEnvironmentDetailsSaga,
    payload: data,
  };
};
